import { Component } from "react";
import { render } from "@testing-library/react";

import "../../styles/frontend/Tarjetas.css"

class RenderFrontEnd extends Component{

    render(){
        return (
            <div className="tarjeta">
                <a href={this.props.link} target="_blank">
                <div className="divCardTitle">
                    <h2 className="cardTitle">{this.props.titulo}</h2>
                </div>

                <div className="divCardImage">
                    
                        <img src={this.props.imagen} alt={this.props.alter} className="imagenTarjeta"></img>
                    
                </div>
                </a>
            </div>
            
            );
    }
}

export default RenderFrontEnd;